module.exports = __webpack_public_path__ + "img/Vector 36.1a099415.png";